// chart-arret-poi.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartArretPoiComponent } from './chart-arret-poi.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [ChartArretPoiComponent],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [ChartArretPoiComponent] // Export the component to be used in other modules
})
export class ChartArretPoiModule { }
